module.exports = function getResource(label, vars = []) {
    let resources = {
        accountInfoTitle: 'Account Information'
    };
    return resources[label];
};
